import React from 'react'
import RsuiteDateRangePicker from 'rsuite/DateRangePicker'
import './index.css'

export default function DateRangePicker(props) {
  return <RsuiteDateRangePicker {...props} />
}
